import { Factory } from 'fishery'
import { v4 as uuidV4 } from 'uuid'
import { OpalApiResponseDocument } from '@opallabs/api'
import { creatorFactory } from './creator'

type RelatedBoard = OpalApiResponseDocument<
  'ExperimentalReadBlockBFFV1',
  200
>['data']['boards'][number]

export const relatedBoardFactory: Factory<RelatedBoard> =
  Factory.define<RelatedBoard>(
    ({ sequence }) =>
      ({
        id: uuidV4(),
        title: `Related Board ${sequence}`,
        description: null,
        image_source: null,
        is_public: false,
        creator: creatorFactory.build(),
      }) satisfies RelatedBoard
  )
